class BlogGridLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more-btn]');
    this.grid = this.closest('.blog-grid')?.querySelector('.blog-grid__articles');
    if (!this.button || !this.grid || !this.dataset.nextUrl) return;

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.#loadMore();
    });
  }

  async #loadMore() {
    if (this.loading || !this.dataset.nextUrl) return;

    this.loading = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.disabled = true;

    try {
      const url = new URL(this.dataset.nextUrl, window.location.origin);
      if (this.dataset.sectionId) {
        url.searchParams.set('section_id', this.dataset.sectionId);
      }

      const html = await fetch(url.toString()).then((r) => {
        if (!r.ok) throw new Error('Failed to load more posts');
        return r.text();
      });

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('.blog-grid__card');

      if (cards.length === 0) {
        this.remove();
        return;
      }

      cards.forEach((card) => this.grid.appendChild(card));

      const nextComponent = doc.querySelector('blog-grid-load-more');
      const nextUrl = nextComponent?.dataset?.nextUrl;

      if (nextUrl) {
        this.dataset.nextUrl = nextUrl;
      } else {
        this.remove();
      }
    } catch {
      this.button.disabled = false;
    } finally {
      this.loading = false;
      this.button.removeAttribute('aria-busy');
      if (this.isConnected) this.button.disabled = false;
    }
  }
}

if (!customElements.get('blog-grid-load-more')) {
  customElements.define('blog-grid-load-more', BlogGridLoadMore);
}
